import React, { ReactNode } from 'react';
import { styled } from '@cp/ds/src/theme';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { useDeclination } from '@cp/shared/declination';
import { DeclinationMnemonic } from '@common/model/resource/declinationMnemonic';

export const name = 'ExperienceLabel';
const Root = styled(Box, { name })(({ theme }) => ({
  // Common styles may be moved to UI
  display: 'inline-flex',
  border: '1px solid',
  borderColor: 'rgb(221, 230, 235)',
  borderRadius: '6px',
  paddingInlineStart: theme.spacing(1),
  paddingInlineEnd: theme.spacing(1),
  paddingBlockStart: '6px',
  paddingBlockEnd: '6px',
  backgroundColor: theme.palette.background.default,
  alignItems: 'center',
  // ExperienceLabel specific styles
  flexGrow: 1,
  gap: theme.spacing(1),
}));

export interface ExperienceLabelProps extends BoxProps {
  experience?: number;
  period?: DeclinationMnemonic.Day | DeclinationMnemonic.Month | DeclinationMnemonic.Year;
  before?: ReactNode;
  after?: ReactNode;
}

export const ExperienceLabel = ({ experience, period = DeclinationMnemonic.Year, before, after, ...props }: ExperienceLabelProps) => {
  const declination = useDeclination();
  if (typeof experience === undefined) {
    return null;
  }
  return (
    <Root {...props}>
      {before}
      Опыт работы {experience} {declination(experience ?? 0, period)}
      {after}
    </Root>
  );
};
